import { render } from "./asset-alarm-position.vue?vue&type=template&id=96fc7c72&scoped=true"
import script from "./asset-alarm-position.vue?vue&type=script&lang=js"
export * from "./asset-alarm-position.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-96fc7c72"

export default script